var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E6ECF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0731 12.88C11.7689 13.5859 12.6108 14.1309 13.5398 14.4767L14.7964 13.4767C14.8337 13.451 14.8779 13.4373 14.9231 13.4373C14.9683 13.4373 15.0125 13.451 15.0498 13.4767L17.3831 14.98C17.4717 15.0333 17.5467 15.1064 17.6021 15.1936C17.6576 15.2809 17.692 15.3798 17.7027 15.4826C17.7134 15.5854 17.7 15.6893 17.6636 15.786C17.6272 15.8828 17.5688 15.9697 17.4931 16.04L16.3998 17.12C16.2432 17.2747 16.0507 17.3883 15.8396 17.4505C15.6285 17.5128 15.4052 17.5217 15.1898 17.4767C13.0405 17.0328 11.0595 15.9932 9.47309 14.4767C7.92192 12.9451 6.84851 10.9963 6.38309 8.8667C6.33711 8.65458 6.34671 8.43418 6.41095 8.22686C6.47519 8.01954 6.59189 7.83233 6.74975 7.68337L7.88309 6.59004C7.95322 6.51796 8.03875 6.46269 8.13327 6.42836C8.22779 6.39403 8.32885 6.38152 8.42889 6.39178C8.52893 6.40205 8.62535 6.4348 8.71093 6.48761C8.79652 6.54041 8.86904 6.61189 8.92309 6.6967L10.4764 9.00004C10.5032 9.0362 10.5177 9.08002 10.5177 9.12504C10.5177 9.17005 10.5032 9.21387 10.4764 9.25004L9.45309 10.48C9.80828 11.3903 10.3617 12.2102 11.0731 12.88V12.88Z",
    fill: "#647077"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.4f55d5e4b6df1238cf003f3291a18aa8.svg";
export { ForwardRef as ReactComponent };